export const DND_UPLOAD_TYPE = 'DND_UPLOAD';
